/***
 * 客户转化分析
 */
import { post, get, postJson, put } from '../axios'
const RESOURCE_BASE_PATH = '/rfm-analyse'

// 客户转化分析汇总
export const customerConversion = p => get(`${RESOURCE_BASE_PATH}/customerConversion`, p);

// 客户转化分析汇总
export const orderTrend = p => get(`${RESOURCE_BASE_PATH}/orderTrend`, p);

// 导出数据
export const exportData = p => get(`${RESOURCE_BASE_PATH}/customerConversionAndOrderTrend/export`, p);

export const exportDataOne = p => get(`/rfm-analyse/customerConversionAndOrderTrend/export`,p);


